export default {
    screen: 'экран',
    podZoom: 'Капсула - зум',
    podInfrared: 'Капсула - инфракрасная',
    podWideAngle: 'Рак - широкоугольный',
    forwardLookingFPV: 'Предыдущий FPV',
    downLookingLens: 'Камера нижнего обзора',
    rearViewLens: 'Сзади',
}